import React, { useEffect, useState } from 'react';
import CuadroDatos from '../../UI/CuadroDatos.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import * as CondicionLocalia from '../../constantes/CondicionLocalia.js';
import * as DataPartidos from '../../data/DataPartidos.js';
import { getCategoriaIdRival } from '../../funciones/FuncionesHistoriales.js';
import styles from './HistorialRival.module.css';
import { Link } from 'react-router-dom';

const HistorialRival = (props) => {
  const club = props.club;
  const rival = props.rival;
  const filtro = props.filtro;
  const [totales, setTotales] = useState([]);
  const { isCargando, erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  const idClub = club && club.id;
  const tipoRival = rival && rival.tipo.id;
  const idRival = rival && rival.objeto && rival.objeto.id;
  const idCategoria = getCategoriaIdRival(rival);

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (idClub) {
      const idBusqueda = idRival ? idRival : idClub;
      const path = DataPartidos.PathClubTipoRival(idClub, tipoRival);
      if (path) {
        const url = DataPartidos.URLTotalesPartidos(path, idBusqueda, filtro, idCategoria);
        fetchData(url, setTotales);
      }
    } else {
      setTotales([]);
    }
  }, [fetchData, idClub, filtro, tipoRival, idRival, idCategoria]);

  const tituloCondicion = (condicion) => {
    switch (condicion) {
      case CondicionLocalia.TODOS: {
        return 'Total';
      }
      case CondicionLocalia.LOCAL: {
        return 'Local';
      }
      case CondicionLocalia.VISITANTE: {
        return 'Visitante';
      }
      case CondicionLocalia.NEUTRAL: {
        return 'Neutral';
      }
      default: {
        return '';
      }
    }
  };

  return (
    <CuadroDatos titulo="Totales" isCargando={isCargando} errores={erroresGetLista}>
      {!isCargando && !erroresGetLista && (
        <React.Fragment>
          {totales.length > 0 ? (
            <table className={`${styles.tablaTotales}`}>
              <thead>
                <tr>
                  <th className={`${styles.columnaTitulo}`}></th>
                  <th className={`${styles.columnaValor}`}></th>
                </tr>
              </thead>
              <tbody>
                {totales.map((item, index) => (
                  <React.Fragment>
                    <tr key={index} className={`${styles.filaCondicion}`}>
                      <td className={`${styles.condicion}`}>{tituloCondicion(item.condicion)}</td>
                      <td className={`${styles.totalPartidos}`}>{item.partidosJugados}</td>
                    </tr>
                    <tr key={index + 'PG'}>
                      <td className={`${styles.filaTitulo}`}>{club.nombre}</td>
                      <td className={`${styles.filaValor}`}>{item.partidosGanadosPropios}</td>
                    </tr>
                    <tr key={index + 'PE'}>
                      <td className={`${styles.filaTitulo}`}>Empates</td>
                      <td className={`${styles.filaValor}`}>{item.partidosEmpatados}</td>
                    </tr>
                    <tr key={index + 'PP'}>
                      <td className={`${styles.filaTitulo}`}>
                        {rival.objeto && rival.objeto.nombre}
                      </td>
                      <td className={`${styles.filaValor}`}>{item.partidosGanadosRival}</td>
                    </tr>
                    <tr key={index + 'GF'}>
                      <td className={`${styles.filaTitulo}`}>Goles {club.nombre}</td>
                      <td className={`${styles.filaValor}`}>{item.golesPropios}</td>
                    </tr>
                    <tr key={index + 'GC'}>
                      <td className={`${styles.filaTitulo}`}>
                        Goles {rival.objeto && rival.objeto.nombre}
                      </td>
                      <td className={`${styles.filaValor}`}>{item.golesRival}</td>
                    </tr>
                    {item.observaciones && item.observaciones.length > 0 && (
                      <React.Fragment>
                        {item.observaciones.map((obs, obsIndex) => (
                          <tr
                            key={index + 'Obs' + obsIndex}
                            className={`${styles.filaObservaciones}`}
                          >
                            <td colSpan="2">
                              <Link
                                to={`/partido/${obs.idPartido}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                (*)
                              </Link>
                              {' ' + obs.observaciones}
                            </td>
                          </tr>
                        ))}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          ) : (
            <span className={`${styles.noPartidos}`}>No se enfrentaron</span>
          )}
        </React.Fragment>
      )}
    </CuadroDatos>
  );
};

export default HistorialRival;
